<template>
    <div class="upload-container">
        <div
            id="upload-loader"
            class="loading loading-double"
            v-if="showLoader"
        ></div>
        <div class="flex">
            <div v-if="showPrevImage" :class="{ fullwidth: showPrevImage }">
                <div class="dropzone form-control flex flex-center">
                    <div v-if="filedata">
                        <div
                            class="thumb"
                            v-if="
                                filedata.substr(
                                    filedata.lastIndexOf('.') + 1
                                ) == 'pdf'
                            "
                        >
                            <span class="filename">{{
                                filedata.replace(
                                    api_asset_url + "/uploads/" + folder + "/",
                                    ""
                                )
                            }}</span>
                            <a v-on:click="removeImage()" class="delete-image"
                                ><i class="ion-trash-a"></i
                            ></a>
                        </div>
                        <div class="thumb" v-else>
                            <img :src="filedata" alt="" />
                            <a v-on:click="removeImage()" class="delete-image"
                                ><i class="ion-trash-a"></i
                            ></a>
                        </div>
                    </div>
                    <div v-else>
                        <div class="thumb" v-if="files.extension == 'pdf'">
                            <span class="filename">{{
                                files.original.replace(
                                    "/uploads/" + folder + "/",
                                    ""
                                )
                            }}</span>
                            <a v-on:click="removeImage()" class="delete-image"
                                ><i class="ion-trash-a"></i
                            ></a>
                        </div>
                        <div class="thumb" v-else>
                            <img :src="files.url" alt="" />
                            <a v-on:click="removeImage()" class="delete-image"
                                ><i class="ion-trash-a"></i
                            ></a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="fullwidth" :class="{ hide: showPrevImage }">
                <div
                    :ref="dropid"
                    class="dropzone form-control dropContainer"
                ></div>
            </div>
        </div>
    </div>
</template>
<style lang="scss">
@import "~dropzone/dist/dropzone.css";
.hide {
    display: none !important;
}
.filename {
    background: #f3f3f3;
    padding: 10px;
    border-radius: 10px;
    text-align: center;
    line-height: 24px;
}
.upload-container {
    position: relative;
    padding: 0;
}
.dropzone.form-control {
    height: auto;
}
#upload-loader {
    position: absolute;
    z-index: 100;
    right: 10px;
    top: 10px;
    margin: 0;
}
.thumb {
    display: flex;
    align-items: center;
    img {
        width: 100%;
    }
}
.dropContainer {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
}
.boxed {
    width: 100%;
    height: 100%;
    flex-wrap: wrap;
}
.flex {
    display: flex;
}
.flex-center {
    justify-content: center;
    align-items: center;
}
.delete-image {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    right: -10px;
    top: -10px;
    font-size: 14px;
    background-color: #c00;
    width: 30px;
    height: 30px;
    border-radius: 100px;
    line-height: 30px;
    text-align: center;
    cursor: pointer;
    color: #fff;
}
.delete-image:hover {
    background-color: #333;
}
.delete-image img {
    width: 15px;
}
.thumb {
    position: relative;
    max-width: 200px;
    margin: 0 auto;
}
.dropzone {
    border: 1px solid #d7d7d7;
    padding: 20px;
}
.dz-clickable {
    cursor: pointer;
}
.dz-image img {
    width: 100%;
}
.dropzone .dz-message {
    margin: 0;
}
.dropzone .dz-preview {
    margin: 0;
}
.upload-placeholder {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.upload-placeholder i {
    font-size: 40px;
}
.upload-placeholder span {
    font-size: 12px;
    display: block;
    position: relative;
}
.fullwidth {
    width: 100%;
    flex: 0 0 100%;
    max-width: 100%;
}
.dropzone .dz-preview .dz-remove {
    display: none;
}
</style>
<script>
import Dropzone from "dropzone";
Dropzone.autoDiscover = false;
export default {
    props: [
        "limit",
        "modelurl",
        "dropid",
        "size",
        "model",
        "endpoint",
        "filetype",
        "extension",
        "folder",
        "placeholder",
        "user"
    ],
    data() {
        return {
            api_asset_url: api_asset_url.replace("/api/v1", ""),
            data: null,
            file_name: [],
            files: null,
            images: [],
            myDropzone: null,
            showLoader: false,
            showPrevImage: false,
            hideDropzone: false,
            filedata: null
        };
    },
    mounted() {
        var self = this;
        this.myDropzone = new Dropzone(this.$refs[this.dropid], {
            url: this.endpoint,
            headers: {
                Authorization: `Bearer ${asset_token}`
            },
            clickable: true,
            maxFiles: this.limit,
            chunking: false,
            maxFilesize: 1000,
            chunkSize: 100,
            acceptedFiles: this.extension,
            addRemoveLinks: true,
            dictDefaultMessage:
                "<div class='upload-placeholder'><i class='ion-upload'></i><span>" +
                this.placeholder +
                "</span></div>",
            success: function(file, response) {
                var response = JSON.parse(file.xhr.response);
                self.$emit("uploaded", { data: response, type: "create" });
                self.files = response[0];
                self.showLoader = false;
                self.showPrevImage = true;
                self.hideDropzone = true;
            },
            error: function(file, response) {
                console.log(response);
                self.$emit("uploaded", {
                    data: { [self.folder]: "Maximum Upload 1Mb" },
                    type: "error"
                });
                self.clearDropzone();
                self.files = null;
                self.showPrevImage = false;
                self.hideDropzone = false;
                self.showLoader = false;
            }
        });
        this.myDropzone.on("removedfile", function(file) {
            self.showLoader = true;
        });
        this.myDropzone.on("addedfile", function() {
            self.showLoader = true;
        });
        this.myDropzone.on("sending", function(file, xhr, formData) {
            self.showLoader = true;
            formData.append("_token", token);
            formData.append("folder", self.folder);
            formData.append("title", self.user.slug + "-" + self.user.email);
            formData.append("size", JSON.stringify(self.size));
        });
        this.myDropzone.on("success", function(file, responseText) {});
    },
    created() {
        if (this.model) {
            if (this.model != "null") {
                this.filedata = this.model;
                this.showPrevImage = true;
                this.hideDropzone = true;
            }
        } else {
            this.showPrevImage = false;
            this.hideDropzone = false;
        }
    },
    methods: {
        clearDropzone() {
            this.myDropzone.removeAllFiles(true);
        },
        addName(id) {
            let file = this.files.filter(x => {
                if (x.id == id) {
                    x.title = this.file_name[id];
                }
            });
        },
        defaultFileName(item, index) {
            this.file_name[item.id] = item.title;
        },
        removeImage() {
            this.clearDropzone();
            this.showLoader = false;
            this.showPrevImage = false;
            this.hideDropzone = false;
            this.$emit("uploaded", { data: self.folder, type: "remove" });
        }
    }
};
</script>
